<template>
  <span class="sup-label">
    <slot />
  </span>
</template>

<style scoped>
.sup-label {
  font-size: var(--font-size-14px);
  font-weight: var(--font-weight-medium);
}
.gray-1 {
  color: var(--font-gray-1);
}
.main {
  color: var(--main);
}
.white {
  color: var(--font-white);
}
</style>
